import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://kxdqlbjohtsrkhaixekp.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt4ZHFsYmpvaHRzcmtoYWl4ZWtwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxMjI4OTksImV4cCI6MjA5MzY5ODg5OX0.-TCvZZ4J-GnieKa7UT5z3728kdf1F76k9S-fNjZ54qg'
export const supabase = createClient(supabaseUrl, supabaseAnonKey)